import { store } from '@core/Store'
import { queryClient } from '@core/Data/ReactQuery'
import { setShouldAllowPendingRacingTicketCountPolling } from '@core/Areas/AppHeader/Store'
import { kambiPendingTicketsPollingQuery, racingPendingTicketsPollingQuery } from './queries'

export function invalidateRacingPendingTicketsQueryData() {
  queryClient.invalidateQueries(racingPendingTicketsPollingQuery)
  store.dispatch(setShouldAllowPendingRacingTicketCountPolling(true))
}

export function invalidateKambiPendingTicketsQueryData() {
  queryClient.invalidateQueries(kambiPendingTicketsPollingQuery)
}
